import useSWR from 'swr';
import { IAccountResult } from '../../utils/types';
import { useFetcher } from './use-fetcher';

/**
 * Custom hook to fetch account data.
 */
export function useAccount() {
  const fetcher = useFetcher();

  const { data, error, isLoading, mutate } = useSWR<IAccountResult>(
    `/api/member/account`,
    fetcher,
  );

  return {
    data,
    error,
    isLoading,
  };
}
